import { useState, useEffect } from 'react';

export default function WhatsAppButton() {
  const [hovered, setHovered] = useState(false);
  const [clicked, setClicked] = useState(false);
  const [visible, setVisible] = useState(false);
  const [showBubble, setShowBubble] = useState(false);

  useEffect(() => {
    const t1 = setTimeout(() => setVisible(true), 1200);
    const t2 = setTimeout(() => setShowBubble(true), 2800);
    const t3 = setTimeout(() => setShowBubble(false), 6500);
    return () => { clearTimeout(t1); clearTimeout(t2); clearTimeout(t3); };
  }, []);

  const handleClick = () => {
    setClicked(true);
    setTimeout(() => setClicked(false), 400);
  };

  return (
    <div
      className={`fixed bottom-6 right-6 z-50 flex flex-col items-end gap-3 transition-all duration-500 ${
        visible ? 'opacity-100 translate-y-0' : 'opacity-100 translate-y-16'
      }`}
    >
      {/* Chat bubble */}
      <div
        className={`relative bg-white text-[#111] text-sm font-medium px-4 py-3 rounded-2xl rounded-br-sm max-w-[200px] transition-all duration-500 ${
          showBubble || hovered ? 'opacity-100 translate-y-0 scale-100' : 'opacity-0 translate-y-2 scale-95 pointer-events-none'
        }`}
        style={{ boxShadow: '0 4px 20px rgba(0,0,0,0.15)' }}
      >
        <span className="block font-semibold text-[#25D366] text-xs mb-0.5">Miki Motors</span>
        Olá! Como posso te ajudar? 👋
        {/* Tail */}
        <div className="absolute -bottom-2 right-3 w-0 h-0"
          style={{ borderLeft: '8px solid transparent', borderRight: '0px solid transparent', borderTop: '8px solid white' }}>
        </div>
      </div>

      {/* Main button */}
      <a
        href="https://api.whatsapp.com/send/?phone=5519997889998&text=Olá, gostaria de fazer um orçamento&type=phone_number&app_absent=0"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Fale conosco pelo WhatsApp"
        className="relative flex items-center cursor-pointer"
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        onClick={handleClick}
      >
        {/* Expanded label */}
        <div
          className={`absolute right-16 bg-[#25D366] text-white text-sm font-bold px-4 py-2 rounded-full whitespace-nowrap transition-all duration-300 ${
            hovered ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-3 pointer-events-none'
          }`}
          style={{ boxShadow: '0 4px 16px rgba(37,211,102,0.4)' }}
        >
          Falar no WhatsApp
        </div>

        {/* Pulse rings */}
        <div className="absolute inset-0 rounded-full"
          style={{ animation: 'wp-ring1 2.5s ease-out infinite', background: 'rgba(37,211,102,0.25)', borderRadius: '9999px' }}>
        </div>
        <div className="absolute inset-0 rounded-full"
          style={{ animation: 'wp-ring2 2.5s ease-out infinite 0.6s', background: 'rgba(37,211,102,0.15)', borderRadius: '9999px' }}>
        </div>

        {/* Button circle */}
        <div
          className={`relative w-16 h-16 flex items-center justify-center rounded-full transition-all duration-200 ${
            clicked ? 'scale-90' : hovered ? 'scale-110' : 'scale-100'
          }`}
          style={{ background: 'linear-gradient(135deg, #25D366 0%, #1ebe5d 100%)', boxShadow: '0 6px 24px rgba(37,211,102,0.5)' }}
        >
          <i
            className="ri-whatsapp-line text-white text-3xl"
            style={{ animation: hovered ? 'wp-wiggle 0.4s ease' : 'none' }}
          ></i>
        </div>
      </a>

      <style>{`
        @keyframes wp-ring1 {
          0% { transform: scale(1); opacity: 0.6; }
          100% { transform: scale(2.2); opacity: 0; }
        }
        @keyframes wp-ring2 {
          0% { transform: scale(1); opacity: 0.4; }
          100% { transform: scale(2.6); opacity: 0; }
        }
        @keyframes wp-wiggle {
          0%   { transform: rotate(0deg); }
          25%  { transform: rotate(-15deg); }
          50%  { transform: rotate(15deg); }
          75%  { transform: rotate(-8deg); }
          100% { transform: rotate(0deg); }
        }
      `}</style>
    </div>
  );
}
